import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FirebaseTSFirestore, OrderBy, Where } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { FirebaseTSApp } from 'firebasets/firebasetsApp/firebaseTSApp';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { UserData } from 'src/app/models/user.model';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ChatContentBottomSheetComponent } from 'src/app/tools/chat-content-bottom-sheet/chat-content-bottom-sheet.component';
import { BehaviorSubject, Subscription, fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { FirebaseTSStorage } from 'firebasets/firebasetsStorage/firebaseTSStorage';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/tools/confirmation-dialog/confirmation-dialog.component';
import { BottomBarService } from 'src/app/services/bottom-bar.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit, OnDestroy {
  @ViewChild('messageContainer', { static: false }) private messageContainer: ElementRef;
  @ViewChild('messageInput') messageInput!: ElementRef;
  @ViewChild('photoInput') photoInput!: ElementRef;
  
  private isUserScrolledUp: boolean = false;

  private shouldScrollToBottom = true;

  firestore = new FirebaseTSFirestore();
  storage = new FirebaseTSStorage();
  auth = new FirebaseTSAuth;
  chats: Chat[] = [];
  chats2: Chat[] = [];
  selectedChat: Chat | null = null;
  unSelectedChat: Chat | null = null;
  newMessage: string = '';
  currentUserId: string = "";
  groupedMessages: { date: string; messages: any[] }[] = [];

  isChatSelected: boolean = false;
  showChat: boolean = false;

  private isSmallScreenSubject = new BehaviorSubject<boolean>(this.checkScreenSize());
  isSmallScreen$ = this.isSmallScreenSubject.asObservable();
  private screenSizeSubscription: Subscription;
  isSmallScreen: boolean = this.checkScreenSize();

  gameChanger: boolean = false;

  searchTerm: string = ''; // Pour la recherche

  readonly DEFAULT_PROFILE_IMAGE = 'https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c';

  getProfileImage(url: string | undefined): string {
    return url || this.DEFAULT_PROFILE_IMAGE;
  }

  // Getter pour les chats filtrés
  get filteredChats(): Chat[] {
    if (!this.chats2) return [];
    
    if (!this.searchTerm) {
      return this.chats2;
    }
    
    const searchTermLower = this.searchTerm.toLowerCase();
    return this.chats2.filter(chat => 
      chat.name.toLowerCase().includes(searchTermLower) ||
      (chat.lastMessage && chat.lastMessage.text.toLowerCase().includes(searchTermLower))
    );
  }

  selectedImage: string | null = null;
  selectedFile: File | null = null;
  selectedImageUrl: string | null = null;
  selectedImageFile: File | null = null;

  onFileSelected(event: any, fileType?: 'image' | 'audio'): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    
    if (!file) return;
    console.log('File selected:', file);

    if (!fileType) {
      // Gestion de la prévisualisation d'image pour le chat
      if (file.type.startsWith('image/')) {
        this.selectedFile = file;
        const reader = new FileReader();
        reader.onload = (e: any) => {
          console.log('FileReader onload triggered');
          this.selectedImage = e.target.result;
          this.isTextEntered = true;
          console.log('Image preview URL created:', this.selectedImage);
        };
        reader.readAsDataURL(file);
      }
    } else {
      // Gestion des fichiers pour l'envoi de messages
      this.isTextEntered = true;
      if (fileType === 'image') {
        this.selectedImageFile = file;
        this.selectedImageUrl = URL.createObjectURL(file);
        this.audioBlob = null;
      } else if (fileType === 'audio') {
        this.audioBlob = file;
        this.audioBlobUrl = URL.createObjectURL(file);
        this.selectedImageFile = null;
        this.isRecording = false;
      }
    }
  }

  removeSelectedImage() {
    console.log('Removing selected image');
    this.selectedImage = null;
    this.selectedFile = null;
    this.isTextEntered = false;
    if (this.photoInput) {
      this.photoInput.nativeElement.value = '';
    }
  }

  clearSelectedImage(): void {
    this.selectedImageFile = null;
    this.selectedImageUrl = null;
    this.isTextEntered = false;
  }

  isRecording: boolean = false;
  recordingTime: string = '00:00';
  recordedAudioUrl: string | null = null;
  isTextEntered = false;
  audioBlob: Blob | null = null;
  audioBlobUrl: string | null = null;
  mediaRecorder: MediaRecorder | null = null;
  audioChunks: Blob[] = [];
  enregistrement: string = "enregistrement en cours";

  


  private audioPlayer: HTMLAudioElement;

  @ViewChild('globalAudio', { static: true }) globalAudio: ElementRef<HTMLAudioElement>;
  
  @ViewChildren('audioPlayer') audioPlayers: QueryList<ElementRef<HTMLAudioElement>>;
  currentAudioTime: { [key: string]: string } = {};
  totalDuration: { [key: string]: string } = {};
  currentProgress: { [key: string]: number } = {};

  playAudio(audioElement: HTMLAudioElement) {
    const audioId = audioElement.src;
    // Arrêter tous les autres lecteurs audio
    this.audioPlayers?.forEach(player => {
      if (player.nativeElement !== audioElement) {
        player.nativeElement.pause();
        player.nativeElement.currentTime = 0;
        delete this.currentAudioTime[player.nativeElement.src];
        this.currentProgress[player.nativeElement.src] = 0;
      }
    });

    // Jouer ou mettre en pause l'audio sélectionné
    if (audioElement.paused) {
      audioElement.play();
    } else {
      audioElement.pause();
      audioElement.currentTime = 0;
      delete this.currentAudioTime[audioId];
      this.currentProgress[audioId] = 0;
    }
  }

  onTimeUpdate(event: Event) {
    const audioElement = event.target as HTMLAudioElement;
    const audioId = audioElement.src;
    if (!audioElement.paused) {
      this.currentProgress[audioId] = audioElement.currentTime;
      this.currentAudioTime[audioId] = this.formatTime(audioElement.currentTime);
    }
  }

  onAudioLoaded(event: Event) {
    const audioElement = event.target as HTMLAudioElement;
    const audioId = audioElement.src;
    if (audioElement && isFinite(audioElement.duration)) {
      this.totalDuration[audioId] = this.formatTime(audioElement.duration);
      this.currentProgress[audioId] = 0;
    }
  }

  updateAudioTime(event: Event, audioElement: HTMLAudioElement) {
    const slider = event.target as HTMLInputElement;
    if (audioElement) {
      const newTime = Number(slider.value);
      audioElement.currentTime = newTime;
      this.currentProgress[audioElement.src] = newTime;
      this.currentAudioTime[audioElement.src] = this.formatTime(newTime);
    }
  }

  getCurrentProgress(audioElement: HTMLAudioElement): number {
    return this.currentProgress[audioElement.src] || 0;
  }

  getMaxDuration(audioElement: HTMLAudioElement): number {
    return audioElement?.duration || 0;
  }

  formatTime(time: number): string {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  getAudioDuration(audioElement: HTMLAudioElement): string {
    const audioId = audioElement.src;
    // Si l'audio est en cours de lecture, afficher le temps actuel
    if (this.currentAudioTime[audioId]) {
      return this.currentAudioTime[audioId];
    }
    // Sinon afficher la durée totale stockée
    if (this.totalDuration[audioId]) {
      return this.totalDuration[audioId];
    }
    return '00:00';
  }

  constructor(private dialog: MatDialog, private bottomSheet: MatBottomSheet, private bottomBarService: BottomBarService) {
    // Masquer immédiatement la barre de navigation sur mobile/tablette
    if (window.innerWidth <= 768) {
      this.bottomBarService.hideNavBar();
      this.bottomBarService.showBottomBar(); // Afficher uniquement la barre inférieure
    }
  }

 
  
  ngOnInit(): void {
    // Initialiser isSmallScreen
    this.isSmallScreen = this.checkScreenSize();
    
    // S'assurer que la barre de navigation est masquée sur mobile
    if (this.isSmallScreen) {
      this.bottomBarService.hideNavBar();
    }

    // Écoute les changements de taille d'écran
    this.screenSizeSubscription = fromEvent(window, 'resize')
      .pipe(
        debounceTime(200),
        map(() => this.checkScreenSize())
      )
      .subscribe((isSmall: boolean) => {
        this.isSmallScreen = isSmall;
        if (isSmall) {
          this.bottomBarService.hideNavBar();
          if (!this.selectedChat) {
            this.bottomBarService.showBottomBar();
          }
        } else {
          this.bottomBarService.showNavBar();
          this.bottomBarService.showBottomBar();
        }
      });

    this.currentUserId = this.auth.getAuth().currentUser.uid.toString();
    
    this.loadChats();
    this.screenSizeSubscription = this.isSmallScreen$.subscribe(
      (isSmall) => {
        this.isSmallScreen = isSmall;
        console.log('Taille de l\'écran inférieure à 768px :', isSmall);
        
      }
    );

   
    
  }

 
  ngOnDestroy(): void {
    // Toujours réafficher les deux barres quand on quitte le composant
    this.bottomBarService.showBottomBar();
    this.bottomBarService.showNavBar();
    
    if (this.screenSizeSubscription) {
      this.screenSizeSubscription.unsubscribe();
    }

    this.audioPlayers.forEach((audioElementRef) => {
      const audio = audioElementRef.nativeElement;
      audio.pause();
      audio.src = '';
      audio.load();
  });

    
  }

  

    

  ngAfterViewChecked() {
    // Ne scroll que si on doit le faire
    if (this.shouldScrollToBottom) {
      this.scrollToBottom();
    }
  }

  scrollToBottom(): void {
    try {
      if (this.messageContainer && this.messageContainer.nativeElement && this.shouldScrollToBottom) {
        const element = this.messageContainer.nativeElement;
        element.scrollTop = element.scrollHeight;
      }
    } catch (err) {
      console.error("Erreur lors du scroll vers le bas", err);
    }
  }

  // Détection du scroll manuel vers le haut
  onScroll(): void {
    if (!this.messageContainer) return;
    
    const element = this.messageContainer.nativeElement;
    const atBottom = Math.abs(element.scrollHeight - element.clientHeight - element.scrollTop) < 50;
    this.shouldScrollToBottom = atBottom;
  }

  // Vérifier si la taille de l'écran est inférieure à 768px
  private checkScreenSize(): boolean {
    return window.innerWidth <= 768;
  }

  // Méthode qui sera appelée lors du redimensionnement de la fenêtre
  private onResize(): void {
    const isSmallScreen = this.checkScreenSize();
    this.isSmallScreenSubject.next(isSmallScreen); // Mise à jour de l'état en temps réel
  }


  toggleRecording(): void {
    if (this.isRecording) {
      this.stopRecording();
      this.isRecording = false;
      
    } else {
      this.startRecording();
      this.isRecording = true;
      this.isTextEntered = false;
      
    }
  }

  startRecording(): void {
    // Masquez le champ de texte et le bouton de sélection d'image
    this.isTextEntered = false;

    this.isRecording = true;
    this.audioChunks = [];
    this.recordingTime = "00:00";

    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
      this.mediaRecorder = new MediaRecorder(stream);
      this.mediaRecorder.start();

      this.mediaRecorder.addEventListener("dataavailable", event => {
        this.audioChunks.push(event.data);
      });

      this.mediaRecorder.addEventListener("stop", () => {
        this.audioBlob = new Blob(this.audioChunks, { type: 'audio/mpeg' });
        this.audioBlobUrl = URL.createObjectURL(this.audioBlob);
      });

      // Timer
      let seconds = 0;
      const timer = setInterval(() => {
        if (!this.isRecording) {
          clearInterval(timer);
        } else {
          seconds++;
          const minutes = Math.floor(seconds / 60);
          const displaySeconds = seconds % 60;
          this.recordingTime = `${minutes.toString().padStart(2, '0')}:${displaySeconds.toString().padStart(2, '0')}`;
        }
      }, 1000);
    });
  }

  stopRecording(): void {
    if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
      this.mediaRecorder.stop();
    }
    this.isRecording = false;
    this.isTextEntered = true;
  }

  clearAudio(): void {
    this.audioBlob = null;
    this.audioBlobUrl = null;
    this.audioChunks = [];
    this.isRecording = false;
    this.isTextEntered = false;
  }

  onChatItemClick(chatItem: any) {
    if (window.innerWidth <= 768) {
      // Ouvrir le bottom sheet sur les petits écrans
      this.bottomSheet.open(ChatContentBottomSheetComponent, {
        data: chatItem  // Vous pouvez passer ici le contenu du chat
      });
      
    } else {
      // Logique normale pour les écrans plus grands
    }
  }
  

  loadChats(): void {
    console.log('Loading chats...');
    const currentUserId = this.auth.getAuth().currentUser.uid;
    this.chats2 = []; // Réinitialiser la liste des chats
    
    this.firestore.getCollection({
      path: ["Chats"],
      where: [
        new Where("participants", "array-contains", currentUserId)
      ],
      onComplete: (result) => {
        console.log('Chats loaded:', result.docs);
        result.docs.forEach(doc => {
          const chat = doc.data();
          const chatData: Chat = {
            id: doc.id,
            participants: chat.participants || [],
            messages: [],
            name: '',
            profileUrl: '',
            lastMessage: {
              senderId: currentUserId,
              text: '',
              timestamp: new Date().toISOString(),
              imageUrl: '',
              audioUrl: '',
              read: false
            },
            lastMessageTimeStamp: null,
            unreadCount: 0
          };

          // Trouver l'ID de l'autre participant
          const otherUserId = chat.participants.find(id => id !== currentUserId);

          if (otherUserId) {
            // Obtenir les informations de l'autre utilisateur
            this.firestore.getDocument({
              path: ["Users", otherUserId],
              onComplete: (userDoc) => {
                const userDocument = userDoc.data();
                if (userDocument) {
                  chatData.name = userDocument.publicName;
                  chatData.profileUrl = userDocument.profilePhotoUrl;

                  // Souscrire aux messages du chat en temps réel
                  this.firestore.listenToCollection({
                    name: chatData.id + "_messages",
                    path: ["Chats", chatData.id, "messages"],
                    where: [new OrderBy("timestamp", "desc")], // Obtenir le plus récent en premier
                    onUpdate: result2 => {
                      if (result2.docs.length > 0) {
                        let lastMessageDoc = result2.docs[0]; // Le premier message est maintenant le plus récent
                        let lastMessage = <Message>lastMessageDoc.data();
                        chatData.lastMessage = lastMessage;
                        chatData.lastMessageTimeStamp = lastMessage.timestamp;

                        // Stocker tous les messages
                        chatData.messages = result2.docs.map(doc => <Message>doc.data());

                        // Appeler la méthode pour compter les messages non lus
                        this.getUnreadMessagesCount(chatData.id);

                        // Vérifier et remplacer l'existant ou ajouter une nouvelle discussion
                        const existingChatIndex = this.chats2.findIndex(c => c.id === chatData.id);
                        if (existingChatIndex !== -1) {
                          this.chats2[existingChatIndex] = chatData;
                        } else {
                          this.chats2.push(chatData);
                        }

                        // Tri des chats
                        this.sortChats();
                      }
                    }
                  });
                }
              }
            });
          }
        });
      },
      onFail: (error) => {
        console.error("Erreur lors du chargement des chats:", error);
      }
    });
  }

  // Fonction de tri des chats par lastMessageTimeStamp
  sortChats(): void {
    if (this.chats2) {
      this.chats2.sort((a, b) => {
        const timeA = a.lastMessageTimeStamp ? new Date(a.lastMessageTimeStamp).getTime() : 0;
        const timeB = b.lastMessageTimeStamp ? new Date(b.lastMessageTimeStamp).getTime() : 0;
        return timeB - timeA; // Trier du plus récent au plus ancien
      });
    }
  }

  selectChatClick(chat: Chat) {
    this.selectChat(chat);
  }

  selectChat(chat: Chat): void {
    this.selectedChat = chat;
    this.showChat = true;
    this.isChatSelected = true;
    
    if (this.isSmallScreen) {
      this.bottomBarService.hideBottomBar();
      this.bottomBarService.hideNavBar();
    }
    
    // Marquer tous les messages non lus comme lus
    this.markMessagesAsRead(chat.id);
  }

  backToChatList() {
    this.selectedChat = null;
    this.showChat = false;
    this.isChatSelected = false;
    
    if (this.isSmallScreen) {
      this.bottomBarService.showBottomBar();
      this.bottomBarService.hideNavBar();
    }
    // ... reste du code
  }

  markMessagesAsRead(chatId: string): void {
    const currentUserId = this.auth.getAuth().currentUser.uid;
    
    // Obtenir tous les messages non lus de la sous-collection
    this.firestore.getCollection({
      path: ["Chats", chatId, "messages"],
      where: [
        new Where("read", "==", false),
        new Where("receiverId", "==", currentUserId)
      ],
      onComplete: (result) => {
        result.docs.forEach(doc => {
          // Mettre à jour chaque message non lu
          this.firestore.update({
            path: ["Chats", chatId, "messages", doc.id],
            data: { 
              read: true,
              readTimestamp: new Date().toISOString()
            }
          });
        });

        // Mettre à jour le compteur de messages non lus pour ce chat
        const chatIndex = this.chats2.findIndex(chat => chat.id === chatId);
        if (chatIndex !== -1) {
          this.chats2[chatIndex].unreadCount = 0;
        }
      }
    });
  }

  loadMessages(chatId: string): void {
    this.firestore.stopListeningTo(chatId);
    this.firestore.listenToCollection({
      name: chatId,
      path: ["Chats", chatId, "messages"],
      where: [new OrderBy("timestamp", "asc")],
      onUpdate: (result) => {
        if (this.selectedChat) {
          this.selectedChat.messages = result.docs.map(doc => {
            const message = doc.data() as Message;
            message.id = doc.id;
            return message;
          });
          
          // Mettre à jour les messages groupés
          this.groupedMessages = this.getMessagesGroupedByDate(this.selectedChat.messages);
          
          // Faire défiler vers le bas si nécessaire
          if (!this.isUserScrolledUp) {
            setTimeout(() => this.scrollToBottom(), 100);
          }
        }
      }
    });
  }

  

  getLastMessageFromServer(chatId: string) {
    this.firestore.getCollection({
      path: ["Chats", chatId, "messages"],
      where: [new OrderBy("timestamp", "desc")], // Obtenir le plus récent en premier
      onComplete: (result) => {
        if (result.docs.length > 0) {
          const lastMessage = result.docs[0].data() as Message;
          if (this.selectedChat) {
            this.selectedChat.lastMessage = lastMessage;
            this.selectedChat.lastMessageTimeStamp = lastMessage.timestamp;
          }
        }
      }
    });
  }

  getMessages(chatId: string){
    this.firestore.getCollection(
      {
        path: ["Chats", chatId, "messages"],
        where: [ new OrderBy("timestamp", "asc")],
        onComplete: (result) => {
          result.docs.forEach(
            doc => {
              let post = <Message>doc.data();
              let message = <Message>doc.data() as Message;
              this.selectedChat?.messages.push(message); 
            }
          );
          this.selectedChat.lastMessage = this.selectedChat?.messages[this.selectedChat?.messages.length -1];
         // alert("Le message dernier est: ");
          //alert(this.selectedChat.lastMessage);
         
        },
        onFail: err => {

        }
      }
    );
  }

  getUnreadMessagesCount(chatId: string): void {
    const currentUserId = this.auth.getAuth().currentUser.uid;
  
    this.firestore.listenToCollection({
      name: chatId + "unReadCount",
      path: ["Chats", chatId, "messages"],
      where: [
        new Where("receiverId", "==", currentUserId),
        new Where("read", "==", false)
      ],
      onUpdate: result => {
        const unreadCount = result.docs.length;
        
        // Mettre à jour le compteur dans chats2
        const chatIndex = this.chats2.findIndex(chat => chat.id === chatId);
        if (chatIndex !== -1) {
          this.chats2[chatIndex].unreadCount = unreadCount;
        }
      }
    });
  }
  
  

  

  getCreatorInfo(uuuid: string): string{
    let name: string;
    this.firestore.getDocument(
      {
        path: ["Users", uuuid],
        onComplete: result => {
          let userDocument = <UserData> result.data();
          name = userDocument.publicName;
          
        }
      }
    );
    return name;
  }

  

  onSendClick(): void {
    const messageText = this.messageInput?.nativeElement.value.trim();
    console.log('onSendClick - selectedFile:', this.selectedFile);
    console.log('onSendClick - messageText:', messageText);

    if (this.selectedFile) {
      // Si une image est sélectionnée, l'envoyer avec le texte (s'il y en a)
      console.log('Uploading image with text:', messageText);
      this.uploadImage(messageText, this.messageInput.nativeElement);
    } else if (messageText) {
      // Si seulement du texte, envoyer le message texte
      console.log('Sending text only');
      this.sendMessage(messageText);
      this.messageInput.nativeElement.value = '';
    }
  }

  onKeydown(event: KeyboardEvent) {
    // Si l'utilisateur appuie sur Entrée sans la touche Shift
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault(); // Empêche le saut de ligne
      this.onSendClick(); // Utilise la même logique que le bouton d'envoi
    }
  }

  uploadImage(messageText?: string, messageInput?: HTMLTextAreaElement): void {
    console.log('uploadImage - Starting upload with text:', messageText);
    if (this.selectedFile) {
      const filePath = ['Messages', this.currentUserId, 'Images', new Date().getTime() + '.png'];
      console.log('uploadImage - File path:', filePath);
      
      this.storage.upload({
        uploadName: "uploadImage",
        path: filePath,
        data: { data: this.selectedFile },
        onComplete: (downloadUrl) => {
          console.log('Image uploaded successfully, URL:', downloadUrl);
          console.log('Creating comment with text:', messageText);
          this.createComment(messageText, downloadUrl);
          if (messageInput) {
            messageInput.value = '';
          }
          this.removeSelectedImage();
        },
        onFail: (err) => {
          console.error("Erreur lors de l'upload de l'image:", err);
        }
      });
    }
  }

  createComment(messageText?: string, imageUrl?: string, audioUrl?: string, messageInput?: HTMLTextAreaElement): void {
    if (!this.selectedChat) return;

    const comment: Message = {
      senderId: this.auth.getAuth().currentUser.uid,
      receiverId: (this.selectedChat.participants[0] === this.auth.getAuth().currentUser.uid) 
        ? this.selectedChat.participants[1] 
        : this.selectedChat.participants[0],
      text: messageText || '',
      timestamp: new Date().toISOString(),
      imageUrl: imageUrl || '',
      audioUrl: audioUrl || '',
      read: false
    };

    console.log('Creating comment:', comment);

    this.firestore.create({
      path: ["Chats", this.selectedChat.id, "messages"],
      data: comment,
      onComplete: (docId) => {
        console.log('Message created with ID:', docId);
        
        // Mise à jour du dernier message et de son timestamp
        this.firestore.update({
          path: ["Chats", this.selectedChat!.id],
          data: {
            lastMessage: comment,
            lastMessageTimeStamp: comment.timestamp
          },
          onComplete: () => {
            console.log('Chat updated successfully');
            
            // Mettre à jour le chat localement
            if (this.selectedChat) {
              this.selectedChat.lastMessage = comment;
              this.selectedChat.lastMessageTimeStamp = comment.timestamp;
              this.selectedChat.messages.push(comment);
            }

            // Mettre à jour la liste des chats localement
            const chatIndex = this.chats2.findIndex(c => c.id === this.selectedChat!.id);
            if (chatIndex !== -1) {
              this.chats2[chatIndex].lastMessage = comment;
              this.chats2[chatIndex].lastMessageTimeStamp = comment.timestamp;
            }

            // Recharger les messages du chat actuel
            if (this.selectedChat) {
              this.loadMessages(this.selectedChat.id);
            }

            // Trier les chats après la mise à jour
            this.sortChats();

            if (messageInput) {
              messageInput.value = '';
            }
            
            // Réinitialiser les états
            this.isTextEntered = false;
            this.selectedImageFile = null;
            this.audioBlob = null;
          },
          onFail: (err) => {
            console.error('Failed to update chat:', err);
          }
        });
      },
      onFail: (err) => {
        console.error("Erreur lors de l'envoi du message:", err);
      }
    });
  }

  sendMessage(text: string) {
    if (this.selectedChat) {
      const senderId = this.auth.getAuth().currentUser.uid;
      const message: Message = {
        senderId: senderId,
        receiverId: this.selectedChat.participants.find(id => id !== senderId),
        text: text,
        timestamp: new Date().toISOString(),
        imageUrl: '',
        audioUrl: '',
        read: false
      };

      this.firestore.create({
        path: ["Chats", this.selectedChat.id, "messages"],
        data: message,
        onComplete: (docId) => {
          // Mise à jour du dernier message dans le chat
          this.firestore.update({
            path: ["Chats", this.selectedChat!.id],
            data: {
              lastMessage: message,
              lastMessageTimeStamp: message.timestamp
            }
          });

          // Mise à jour locale du chat
          if (!this.selectedChat.messages) {
            this.selectedChat.messages = [];
          }
          this.selectedChat.messages.push(message);
          this.selectedChat.lastMessage = message;
          this.selectedChat.lastMessageTimeStamp = message.timestamp;
          
          // Mettre à jour la liste des chats localement
          const chatIndex = this.chats2.findIndex(c => c.id === this.selectedChat!.id);
          if (chatIndex !== -1) {
            this.chats2[chatIndex].lastMessage = message;
            this.chats2[chatIndex].lastMessageTimeStamp = message.timestamp;
          }

          // Trier les chats après la mise à jour
          this.sortChats();
          
          // Faire défiler vers le bas
          setTimeout(() => this.scrollToBottom(), 100);
        },
        onFail: (error) => {
          console.error("Erreur lors de l'envoi du message:", error);
        }
      });
    }
  }

  // Fonction pour détecter si du texte a été saisi
  onTextChange(event: Event) {
    const input = event.target as HTMLTextAreaElement;
    this.isTextEntered = input.value.trim().length > 0;
   
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      if (event.shiftKey) {
        // Shift + Enter: Nouvelle ligne
        const textarea = event.target as HTMLTextAreaElement;
        const cursorPosition = textarea.selectionStart;
        this.newMessage = this.newMessage.substring(0, cursorPosition) + '\n' + this.newMessage.substring(cursorPosition);
        event.preventDefault(); // Empêche l'action par défaut de l'Enter
      } else {
        // Simple Enter: Envoyer le message
        const textarea = event.target as HTMLTextAreaElement;
        if (textarea.value.trim()) {
          this.createComment(textarea.value);
          textarea.value = '';
          textarea.style.height = 'auto';
        }
        event.preventDefault(); // Empêche l'action par défaut de l'Enter
      }
    }
  }

  adjustTextareaHeight(event: Event) {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }

  async blockUser() {
    if (this.selectedChat) {
      const otherUserId = this.selectedChat.participants.find(id => id !== this.currentUserId);
      if (otherUserId) {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          data: {
            title: 'Bloquer l\'utilisateur',
            message: 'Êtes-vous sûr de vouloir bloquer cet utilisateur ? Cette action est irréversible.'
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.firestore.create({
              path: [`blockedUsers`, `${this.currentUserId}_${otherUserId}`],
              data: {
                blockerId: this.currentUserId,
                blockedId: otherUserId,
                timestamp: new Date()
              }
            });

            // Ouvrir un nouveau dialogue pour confirmer le succès
            this.dialog.open(ConfirmationDialogComponent, {
              data: {
                title: 'Succès',
                message: 'L\'utilisateur a été bloqué avec succès.'
              }
            });
          }
        });
      }
    }
  }

  reportUser(): void {
    if (this.selectedChat) {
      const otherUserId = this.selectedChat.participants.find(id => id !== this.currentUserId);
      if (otherUserId) {
        this.firestore.create({
          path: ['reports'],
          data: {
            reporterId: this.currentUserId,
            reportedId: otherUserId,
            timestamp: new Date(),
            status: 'pending',
            reason: 'Signalement utilisateur'
          }
        });
        alert('Utilisateur signalé avec succès');
      }
    }
  }

  deleteChat(): void {
    if (this.selectedChat) {
      this.firestore.delete({
        path: ["chats", this.selectedChat.id],
        onComplete: () => {
          this.selectedChat = null;
          this.loadChats(); // Recharger la liste des chats
        },
        onFail: (error) => {
          console.error('Erreur lors de la suppression de la discussion :', error);
        }
      });
    }
  }


  

  

  getFormattedDate(timestamp: any): string {
    if (!timestamp) return '';
    
    let date: Date;
    
    // Gestion des différents types de timestamp
    if (timestamp.toDate && typeof timestamp.toDate === 'function') {
      // Timestamp Firestore
      date = timestamp.toDate();
    } else if (timestamp instanceof Date) {
      // Objet Date
      date = timestamp;
    } else if (typeof timestamp === 'string') {
      // String timestamp
      date = new Date(timestamp);
    } else if (typeof timestamp === 'number') {
      // Timestamp en millisecondes
      date = new Date(timestamp);
    } else {
      return '';
    }

    const now = new Date();
    const diffInMinutes = Math.floor((now.getTime() - date.getTime()) / (1000 * 60));
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInMinutes < 1) {
      return 'À l\'instant';
    } else if (diffInMinutes < 60) {
      return `Il y a ${diffInMinutes} min`;
    } else if (diffInHours < 24) {
      return `Il y a ${diffInHours}h`;
    } else if (diffInDays === 1) {
      return 'Hier';
    } else if (diffInDays < 7) {
      return `Il y a ${diffInDays}j`;
    } else {
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
      });
    }
  }

  getLastMessageFormattedDate(chat: Chat): string {
    
    const timestamp = chat.lastMessageTimeStamp ? new Date(chat.lastMessageTimeStamp) : new Date();
    const now = new Date();

    

    // Supprime les heures, minutes, secondes et millisecondes pour comparer uniquement les dates
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const messageDate = new Date(timestamp.getFullYear(), timestamp.getMonth(), timestamp.getDate());

    // Vérifiez si la date du message est aujourd'hui
    if (
        messageDate.getTime() === today.getTime()) {
        return timestamp.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false });
    }

    // Vérifiez si la date du message est hier
    if (messageDate.getTime() === yesterday.getTime()) {
        return 'Hier';
    }

    // Si la date ne correspond ni à aujourd'hui ni à hier, retourne le format jj/mm/aa
    return timestamp.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit' });
}

getMessageFormattedDate(timestamp: any): string {
  const messageDate = timestamp ? new Date(timestamp) : new Date();
  const now = new Date();

  // Calcul de la différence en millisecondes
  const diffInMs = now.getTime() - messageDate.getTime();
  const diffInHours = diffInMs / (1000 * 60 * 60); // conversion en heures
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // conversion en jours

  // Si le message date d'aujourd'hui
  if (diffInHours < 24) {
    return messageDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false });
  } 

  // Si le message date d'hier
  else if (diffInHours >= 24 && diffInHours < 48) {
    return `Hier, ${messageDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false })}`;
  }

  // Si le message est vieux de plus de 48 heures mais dans la même année
  else if (diffInDays >= 2 && now.getFullYear() === messageDate.getFullYear()) {
    return `${messageDate.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })} à ${messageDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false })}`;
  }

  // Si le message date de plus d'une année
  else {
    return messageDate.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit' }) + ' à ' +
           messageDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false });
  }

}

  getMessagesGroupedByDate(messages: Message[]): { date: string; messages: Message[] }[] {
    const groupedMessages: { [key: string]: Message[] } = {};
    
    // Trier les messages par date (du plus ancien au plus récent)
    const sortedMessages = [...messages].sort((a, b) => 
      new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
    );
    
    // Grouper les messages par date
    sortedMessages.forEach(message => {
      const date = this.getMessageFormattedDate(message.timestamp);
      if (!groupedMessages[date]) {
        groupedMessages[date] = [];
      }
      groupedMessages[date].push(message);
    });
    
    // Convertir l'objet en tableau et trier les groupes par date
    return Object.entries(groupedMessages)
      .map(([date, messages]) => ({ date, messages }))
      .sort((a, b) => {
        const dateA = new Date(a.messages[0].timestamp).getTime();
        const dateB = new Date(b.messages[0].timestamp).getTime();
        return dateA - dateB;
      });
  }

  getLastMessageContent(chat: Chat): string{
    return chat.messages && chat.messages.length > 0 ? chat.messages[chat.messages.length - 1].text : '';
    
    /*if(chat.messages && chat.messages.length > 0){ 

      const lastMessage: Message =  chat.messages[chat.messages.length - 1];
      
      return lastMessage.text;
     }else{
     } */
  }

  loadUserProfile(uuid: string): UserData {
    const userId = this.auth.getAuth().currentUser.uid; // Assurez-vous de récupérer l'ID utilisateur correctement
    let user: UserData;
    this.firestore.getDocument({
      path: ["Users", uuid],
      onComplete: result => {
        user = result.data() as UserData;

        if(user.profilePhotoUrl == ""){
          user.profilePhotoUrl = this.DEFAULT_PROFILE_IMAGE;
        }


        if(user.coverPhotoUrl == ""){
          user.coverPhotoUrl = "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/defaultCoverImage.jpg?alt=media&token=d509e05d-dd94-4ff3-b37f-24430c3a82bf";
        }
        
      },
      onFail: err => {
        console.error(err);
      }
    });
    return user;
  }

  

  // Supprimez cette fonction car elle est dupliquée
  // selectChat(chat: Chat): void {
  //   this.selectedChat = chat;
  //   this.showChat = true;
  //   this.isChatSelected = true;
  //   // Marquer les messages comme lus
  //   this.markMessagesAsRead(chat.id);
  // }
}

export interface Message {
  id?: string; 
  senderId: string;
  receiverId?: string;
  text: string;
  timestamp: string;
  audioUrl?: string;
  imageUrl?: string;
  read?: boolean;
  readTimestamp?: string;
}

export interface Chat {
  id: string;
  participants: string[];
  messages: Message[];
  name: string;
  profileUrl: string;
  lastMessage: Message;
  lastMessageTimeStamp: any;
  unreadCount: number;
 
}
